import React from "react";

import { StyledPagination } from "./styledPagination";

export default function PaginationComponent(props) {
  return (
    <StyledPagination
      count={props.pageNumber}
      size="large"
      shape="rounded"
      page={props.currentPage}
      onChange={props.handleChangePage}
      className={props.className}
      showFirstButton={false}
    />
  );
}
